<template>
  <div class="content if-profile report-tab">
    <div class="md-layout financal-report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
        <VRHeader :headerData="this.headerData" />
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4">
        <div class="md-layout">
          <div class="md-layout-item p-0">
            <md-card>
              <div class="md-layout if_card">
                <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                  <md-card-header class="md-card-header-icon">
                    <span v-if="this.companyName">{{ this.companyName }}</span>
                    <span v-else>Business </span> Values
                  </md-card-header>

                  <md-card-content>
                    <div class="extra_space">
                      <p>
                        Sales approach values are rarely applied to firms with
                        sales of less than $2.5 million.
                      </p>
                    </div>
                    <div class="md-layout px-4">

                      <div class="md-layout-item md-medium-size-100 md-size-50">
                        <profile-card header-color="blue" class="text-card scores-list-star other-value">
                          <template slot="header" header-color="rose">
                            <h4 class="title m-0">
                              <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                Business Value Approaches
                              </div>
                            </h4>
                          </template>
                          <template slot="content">
                            <div class="extra_space">
                              <p>
                                Vestimate-Pro reports develop both "asset sale" and "equity sale" values for earnings
                                and revenue approach valuation methods. These approaches are coupled with benchmarks for
                                key financial ratios and market metrics which compare the analyzed firm’s liquidity,
                                profitability, efficiency, debt-risk performance and market opportunity to industry peer
                                group standards. The result is a meaningful analysis and final value estimates that make
                                sense in the real world, providing useful information to valuation professionals,
                                brokers, sellers, entrepreneurs, investors and advisors.
                                <br>
                                <br>
                                <strong>Asset Value Earnings Basis:</strong> This approach applies Price/Earnings
                                multiples to actual firm earnings. The applied Price/Earnings multiples are specific to an industry multiple
                                sales bracket (of four). Based on industry and firm financial inputs, a series of core
                                KPIs specific to the industry peer sales class size (of fifteen) is then scored and
                                applied to adjust the base analysis and create a final value or value range. This
                                approach generally assumes that current assets and all liabilities remain with the
                                seller.
                                <br>
                                <br>

                                <strong>Equity Value Earnings Approach and Equity Value Revenue Basis Approach: </strong>Both Equity
                                Value approaches use the same initial calculations as the corresponding Asset Value
                                Earnings Basis and Asset Value Revenue Basis approaches, but adjust the values with the
                                difference between assets and liabilities from the balance sheet. These approaches are
                                generally used for 100% sales of equity (stock) only.
                                <br>
                                <br>
                                Which to use? Owner-operated businesses are most commonly sold on an asset sale basis.
                                Determination of the most appropriate Approach or Basis should be made in conjunction
                                with a broker or valuation professional acquainted with the detailed specifics of the
                                business and the purpose of the valuation.
                              </p>
                            </div>
                          </template>
                        </profile-card>

                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50">
                        <md-card class="m-0">
                          <md-card-header class="md-card-header-icon">
                            <h4 class="Performance Scores">Valuation Drivers</h4>
                            <p>
                              While a broad range of factors affects every
                              valuation, the core analysis often relies on three
                              yardsticks: sales volume, sales growth and owner
                              earnings. The larger these factors and the higher
                              their growth, the higher the ultimate business
                              value tends to be. Sales volume is itself a
                              differentiating factor in determining price
                              multiples, whether Price/Sales or Price/Earnings.
                              In general, multiples tend to increase with firm
                              size on an industry-specific basis. In this case,
                              the subject firm falls into the sales class A
                              bracket of $ 2.5m. (Multiples are divided into
                              four sales brackets.) Other key factors include
                              not only Sales and Owner Earnings as current
                              multiples, but also the growth of each, as
                              displayed in the chart:
                            </p>
                          </md-card-header>
                          <md-card-content class="chartHeader border-0">

                            <chart-card header-animation="false" :chart-data="valuationLineChart.data"
                              :chart-options="valuationLineChart.options" chart-type="Line" header-icon
                              chart-inside-content cv background-color="blue">
                              <template slot="chartInsideHeader">
                                <div class="card-icon">
                                  <md-icon>timeline</md-icon>
                                </div>
                                <h4 class="title">
                                  {{ this.vestimateReport.timeSeries }}
                                  Valuation Drivers ($)
                                </h4>
                              </template>
                              <template slot="footer">
                                <div class="pie-line">
                                  <ul>
                                    <li><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                    <li><span><i class="fa fa-square grey-color"></i></span>Sales Approach:</li>
                                  </ul>
                                </div>
                              </template>
                            </chart-card>
                            <!-- <p>These factors are analyzed along with a scored set of financial metrics to develop final
                              Valution business values. Firm financial data is benchmarked against industry peer group
                              values for up to three years, depending on inputs. While all three years of industry data are
                              displayed, only those years for which firm inputs were developed are shown and used in
                            Valution calculations.</p>-->
                          </md-card-content>
                        </md-card>
                      </div>
                    </div>
                    <div class="md-layout px-4">
                      <div class="md-layout-item md-medium-size-100 md-size-50">
                        <profile-card header-color="blue" class="text-card">
                          <template slot="header">
                            <h4 class="Performance Scores card-title m-0">Historial Business Values</h4>
                          </template>
                          <template slot="content">
                            <div class="extra_space">
                              <h5 class="table_header">Historical Trend Values (excludes growth KPIs)</h5>
                              <table class="table1">
                                <tr v-for="earning in historical_earnings" :key="earning.id">
                                  <td>{{ earning.year }} Earnings Value:</td>
                                  <td>Earnings Approach</td>
                                  <td>{{ earning.value }}</td>
                                </tr>
                                <tr v-for="income in historical_income" :key="income.id">
                                  <td>{{ income.year }} Asset Sale Value:</td>
                                  <td>Sales Approach:</td>
                                  <td>{{ income.value }}</td>
                                </tr>
                              </table>


                            </div>
                          </template>
                        </profile-card>
                        <profile-card header-color="blue" class="text-card">
                          <template slot="header">
                            <h4 class="Performance Scores card-title m-0">Asset Sale Value</h4>
                          </template>
                          <template slot="content">
                            <table>
                              <tr>
                                <td>Earnings Approach:</td>
                                <td>{{ this.vestimateReport.vestimate.earnings }}</td>
                              </tr>
                              <tr>
                                <td>Sales Approach:</td>
                                <td>{{ this.vestimateReport.vestimate.income }}</td>
                              </tr>
                            </table>
                          </template>
                        </profile-card>
                        <profile-card header-color="blue" class="text-card">
                          <template slot="header">
                            <h4 class="Performance Scores card-title m-0">Equity Sale Value</h4>
                          </template>
                          <template slot="content">
                            <table>
                              <tr>
                                <td>Earnings Approach:</td>
                                <td>
                                  {{
                                  this.vestimateReport.vestimate
                                  .earnings_equity
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>Sales Approach:</td>
                                <td>
                                  {{
                                  this.vestimateReport.vestimate.income_equity
                                  }}
                                </td>
                              </tr>
                            </table>
                          </template>
                        </profile-card>
                        <profile-card header-color="blue" class="text-card">
                          <template slot="header">
                            <h4 class="Performance Scores card-title m-0">Key Value Drivers</h4>
                          </template>
                          <template slot="content">
                            <table>
                              <tr v-if="sales_value">
                                <td>Sales:</td>
                                <td>${{ sales_value.replaceAll('.',',')}}</td>
                              </tr>
                              <tr v-if="sales_growth">
                                <td>
                                  Sales Growth
                                  {{ vestimateReport.IF['timeSeries'] }}:
                                </td>
                                <td>{{ sales_growth }}</td>
                              </tr>
                              <tr v-if="earning_value">
                                <td>Discretionary Owner Earnings:</td>
                                <td>{{ earning_value }}</td>
                              </tr>
                              <tr v-if="earning_growth">
                                <td>
                                  Discretionary Owner Earnings Growth
                                  {{ vestimateReport.IF.timeSeries }}:
                                </td>
                                <td>{{ earning_growth }}</td>
                              </tr>

                            </table>
                          </template>
                        </profile-card>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50">
                        <md-card-header class="md-card-header-icon">
                          <h4 class="Performance Scores">{{ vestimateReport.IF.timeSeries }} Historical Value Trend</h4>
                          <p>
                            These factors are analyzed along with a scored set
                            of financial metrics to develop final Valuations
                            business values. Firm financial data is benchmarked
                            against industry peer group values for up to three
                            years, depending on inputs. While all three years of
                            industry data are displayed, only those years for
                            which firm inputs were developed are shown and used
                            in Valuations calculations.
                          </p>
                        </md-card-header>
                        <md-card-content class="chartHeader border-0">
                          <chart-card header-animation="false" :chart-data="historiacalLineChart.data"
                            :chart-options="historiacalLineChart.options" chart-type="Line" header-icon
                            chart-inside-content cv background-color="blue">
                            <template slot="chartInsideHeader">
                              <div class="card-icon">
                                <md-icon>timeline</md-icon>
                              </div>
                              <h4 class="title">
                                {{ vestimateReport.IF['timeSeries'] }}
                                Historical Value Trend ($)
                              </h4>
                            </template>
                            <template slot="footer">
                              <div class="pie-line">
                                <ul>
                                  <li><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                  <li><span><i class="fa fa-square grey-color"></i></span>Sales Approach:</li>
                                </ul>
                              </div>
                            </template>
                          </chart-card>
                        </md-card-content>
                      </div>
                    </div>
                  </md-card-content>
                </div>
              </div>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VRHeader from './_partials/VRHeader';
import { ChartCard, ProfileCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';

export default {
  components: {
    ChartCard,
    ProfileCard,
    VRHeader,
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      valuationLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
      historiacalLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
      sales_value: '',
      sales_growth: '',
      earning_value: '',
      earning_growth: '',
      historical_earnings: [],
      historical_income: [],
      chartYears: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      client: (state) => state.user.vestimate_report.data.developerClient,
      vestimateReport: (state) => state.user.vestimate_report.data,
      naics: (state) => state.user.vestimate_report.data.IMRnaics,
      industryName: (state) => state.user.vestimate_report.data.IMRindustry,
      displayArea: (state) => state.user.vestimate_report.data.MR.area,
      reportDate: (state) => state.user.vestimate_report.data.report_date,
      recentYear: (state) => state.user.vestimate_report.data.recentYear,
      companyName: (state) =>
        state.user.vestimate_report.data.input_structure['Company Name'][
        'value'
        ],
    }),
  },
  mounted() {
    let me = this;

    /*this.sales_value = this.vestimateReport.input_structure.IFInputs[`${this.recentYear}`]['revenue']['value']; // TODO: (RAY) TOOK THIS OUT! Look into fixing this permanently.
    this.sales_value = me.numberWithPoints(this.sales_value);*/

    let lastYearIndex = this.vestimateReport.last_year_index;
    let sales_growth_year = this.vestimateReport.IF.ifDataYears[lastYearIndex];
    this.sales_growth = this.vestimateReport.IF.data[sales_growth_year]['Market Sales Growth']['firm_percentage'];

    let lastYearInput = this.vestimateReport.last_year_of_inputs;
    this.earning_value = this.vestimateReport.IF.data[lastYearInput]['Owner Earnings']['firm_percentage'];
    this.earning_growth = this.vestimateReport.IF.data[sales_growth_year]['Owner Earnings']['percentage'];
    this.vestimateReport.IF.ifDataYears.forEach((el, index) => {
      let earnings = {};
      let income = {};
      earnings.year = el;
      income.year = el;
      if (el !== this.vestimateReport.lastYearValue) {
        earnings.value = this.vestimateReport.vestimate.data[el]['earnings'][
          'sales_value'
        ];
        income.value = this.vestimateReport.vestimate.data[el]['sales'][
          'sales_value'
        ];
      } else {
        earnings.value = this.vestimateReport.vestimate.earnings;
        income.value = this.vestimateReport.vestimate.income;
      }
      this.historical_earnings.push(earnings);
      this.historical_income.push(income);
    });
    let valuation_chart = this.vestimateReport.charts.valuation_drivers_chart
      .data;
    let valuation_years = [];
    let valuation_data = [];
    valuation_chart.forEach((element, index) => {
      valuation_years.push(element.date);
    });
    valuation_years = valuation_years.filter(function (item, pos) {
      return valuation_years.indexOf(item) == pos;
    });
    valuation_chart.forEach((element, index) => {
      let n = {};
      n.name = element.category;
      n.dates = element.value;
      valuation_data.push(n);
    });

    let valueArr = valuation_data.map(function (item) {
      return item.name;
    });
    let valuation_series = [];
    valueArr.some(function (item, idx) {
      if (valueArr.indexOf(item) != idx) {
        let f = {};
        let y = [];
        f.name = item;
        valuation_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            f.dates = y;
          }
        });
        valuation_series.push(f);
      }
    });
    valuation_years = valuation_years.map((item) => item.split('-')[0]);
    valuation_series.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    this.valuationLineChart.data = {
      labels: valuation_years,
      series: valuation_series.map((item) => ({
        name: item.name,
        data: item.dates,
      })),
    };
    let historical_chart = this.vestimateReport.charts
      .historical_vestimate_chart.data;
    let historical_years = [];
    let historical_data = [];
    historical_chart.forEach((element, index) => {
      historical_years.push(element.date);
    });
    historical_years = historical_years.filter(function (item, pos) {
      return historical_years.indexOf(item) == pos;
    });
    historical_chart.forEach((element, index) => {
      let n = {};
      n.name = element.category;
      n.dates = element.value;
      historical_data.push(n);
    });

    var historicalArr = historical_data.map(function (item) {
      return item.name;
    });
    let historical_series = [];
    historicalArr.some(function (item, idx) {
      if (historicalArr.indexOf(item) != idx) {
        let f = {};
        let y = [];
        f.name = item;
        historical_data.forEach((element, index) => {
          if (element.name == item) {
            y.push(element.dates);
            f.dates = y;
          }
        });
        historical_series.push(f);
      }
    });

    historical_years = historical_years.map((item) => item.split('-')[0]);
    historical_series.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    this.historiacalLineChart.data = {
      labels: historical_years,
      series: historical_series.map((item) => ({
        name: item.name,
        data: item.dates,
      })),
    };
  },
  methods: {
    numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
  },
};
</script>
<style lang="scss"></style>
